<template>
  <div style="position: relative; width:960px">
    <el-breadcrumb separator=""
                   style="margin-top: 12px">
      <el-breadcrumb-item>开发支持</el-breadcrumb-item>
      <el-breadcrumb-item><img src="../assets/icon-bread-arrow.svg"
             alt=""></el-breadcrumb-item>
      <el-breadcrumb-item>地理编码</el-breadcrumb-item>
    </el-breadcrumb>
    <anchor class="title-wrap"
            style="width:150px">
      <anchor-link href="#id-product-introduction"
                   title="产品介绍" />
      <anchor-link href="#id-application-scene"
                   title="适用场景" />
      <anchor-link href="#id-instructions-for-use"
                   title="使用说明" />
      <anchor-link href="#id-keyword-geocoding"
                   title="地理编码" />
      <anchor-link href="#id-format"
                   title="地址结构化" />
      <anchor-link href="#id-formatV2"
                   title="地址结构化V2" />
      <anchor-link href="#id-formatV2"
                   title="地址结构化V2" />
    </anchor>
    <div id="content-containter"
         style="width: 788px;">
      <h1>地理编码</h1>
      <span class="time">最后更新时间：2022年01月10日</span>
      <h2 id="id-product-introduction">产品介绍</h2>
      <ul>
        <li>
          <p>
            地理编码API是通过HTTP协议访问远程服务的接口，提供将结构化地址转化为经纬度的服务。 </p>
        </li>
        <li>
          <p>
            地址结构化API是通过HTTP协议访问远程服务的接口，提供将地址拆分为各级别地理实体的服务。 </p>
        </li>
      </ul>
      <h2 id="id-application-scene">适用场景</h2>
      <p>
      <ul>
        <li>
          <p>
            地理编码：将详细的结构化地址转换为美团经纬度坐标，且支持名胜景区、标志性建筑物名称解析为美团经纬度坐标。例如：天安门→116.397499,39.908722
          </p>
        </li>
        <li>
          <p>
            地址结构化：将地址拆分为各级别地理实体。
          </p>
        </li>
      </ul>
      </p>
      <h2 id="id-instructions-for-use">使用说明</h2>
      <p>
      <ul>
        <li>第一步，申请Web服务API类型Key；</li>
        <li>第二步，参考接口文档发起HTTP/HTTPS请求；</li>
        <li>第三步，接收请求返回的JSON数据。</li>
      </ul>
      </p>
      <div id="coding-container">
        <h2 id="id-keyword-geocoding">地理编码</h2>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>地理编码API服务地址</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p>URL</p>
                </th>
                <th>
                  <p>https://lbsapi.meituan.com/v1/location/geo?parameters</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>请求方式</p>
                </td>
                <td>
                  <p>GET</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-request-paramsKeyWord">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>请求参数</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p><strong>参数名</strong></p>
                </th>
                <th>
                  <p><strong>数据类型</strong></p>
                </th>
                <th width="138">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
                <th width="88">
                  <p><strong>是否必填</strong></p>
                </th>
                <th width="70">
                  <p><strong>缺省值</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>key</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>请求服务权限标识</p>
                </td>
                <td>
                  <p>用户申请到的Web服务API Key</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>address</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>结构化地址信息</p>
                </td>
                <td>
                  <p>省+市+区+街道+门牌号</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>city</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>查询所在的城市</p>
                </td>
                <td>
                  <p>city=北京市，只支持city汉字/编码的形式</p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-返回结果参数说明">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>返回结果参数说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="3">
                  <p><strong>名称</strong></p>
                </th>
                <th>
                  <p><strong>类型</strong></p>
                </th>
                <th width="130">
                  <p>
                    <strong><span>含义</span> </strong>
                  </p>
                </th>
                <th>
                  <p>
                    <strong><span>规则说明</span> </strong>
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="3">
                  <p>status</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>返回结果状态值</p>
                </td>
                <td>
                  <p>
                    200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>
                    。
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>msg</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>状态描述</p>
                </td>
                <td>
                  <p>
                    对状态码的简单描述。
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>count</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>返回结果数目</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>geocodes</p>
                </td>
                <td>
                  <p v-text="'array<geocode>'"></p>
                </td>
                <td>
                  <p>结果列表</p>
                </td>
                <td>
                  <p>该接口返回一或多个地理编码结果</p>
                </td>
              </tr>
              <tr>
                <td rowspan="13">
                  <p></p>
                </td>
                <td colspan="2">
                  <p>geocode</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="12">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>formatted_address</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>结构化地址信息</p>
                </td>
                <td>
                  <p>省份＋城市＋区县＋乡镇＋街道＋门牌号码</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>province</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>地址所在的省份名</p>
                </td>
                <td>
                  <p>
                    例如：北京市。此处需要注意的是，中国的四大直辖市、特别行政区也算作省级单位。
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p >pcode</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>省份行政编码</p>
                </td>
                <td>
                  <p>
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>city</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>地址所在的城市名</p>
                </td>
                <td>
                  <p>例如：北京市</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p >citycode</p>
                </td>
                <td>
                  <p >string</p>
                </td>
                <td>
                  <p >城市行政编码</p>
                </td>
                <td>
                  <p >例如：110100</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p >areacode</p>
                </td>
                <td>
                  <p >string</p>
                </td>
                <td>
                  <p >城市区号</p>
                </td>
                <td>
                  <p >例如：010</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>district</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>地址所在的区</p>
                </td>
                <td>
                  <p>例如：朝阳区</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>adcode</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>区域编码</p>
                </td>
                <td>
                  <p>例如：110101</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>street</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>街道</p>
                </td>
                <td>
                  <p>例如：望京东路</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>number</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>门牌号</p>
                </td>
                <td>
                  <p>例如：1号</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>location</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>坐标点</p>
                </td>
                <td>
                  <p>经纬度</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>level</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>最小匹配级别</p>
                </td>
                <td>
                  <p>
                    取值范围:
                    省、市、区县、开发区、乡镇、村庄、门、建筑物、门牌号、单元号、道路、交叉路口、兴趣点
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-地理编码匹配级别列表">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>地理编码匹配级别列表</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p><strong>level</strong></p>
                </th>
                <th>
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p>
                    <strong><span>示例说明</span> </strong>
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>国家</p>
                </td>
                <td>
                  <p>国家级行政区划</p>
                </td>
                <td>
                  <p>中国</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>省</p>
                </td>
                <td>
                  <p>省级行政区划/直辖市/特别行政区</p>
                </td>
                <td>
                  <p>北京市</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>市</p>
                </td>
                <td>
                  <p>地级市/省直辖县/直辖市/特别行政区</p>
                </td>
                <td>
                  <p>北京市</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>区县</p>
                </td>
                <td>
                  <p>区县级行政区划</p>
                </td>
                <td>
                  <p>朝阳区</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>开发区</p>
                </td>
                <td>
                  <p>经济技术开发区等</p>
                </td>
                <td>
                  <p>
                    <span>林河经济开发区</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>乡镇</p>
                </td>
                <td>
                  <p>乡镇</p>
                </td>
                <td>
                  <p>望京街道</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>村庄</p>
                </td>
                <td>
                  <p>村庄</p>
                </td>
                <td>
                  <p>
                    <span>三元村</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>道路</p>
                </td>
                <td>
                  <p>道路</p>
                </td>
                <td>
                  <p>
                    <span>阜通东大街</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>交叉路口</p>
                </td>
                <td>
                  <p>交叉路口</p>
                </td>
                <td>
                  <p>
                    <span>机场东路/顺平路</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>门牌号</p>
                </td>
                <td>
                  <p>门牌号</p>
                </td>
                <td>
                  <p>
                    <span>阜通东大街6号</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>楼栋</p>
                </td>
                <td>
                  <p>楼栋</p>
                </td>
                <td>
                  <p>
                    <span>花家地南里1栋</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>单元号</p>
                </td>
                <td>
                  <p>单元号</p>
                </td>
                <td>
                  <p>
                    <span>花家地南里1号楼1单元</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>兴趣点</p>
                </td>
                <td>
                  <p>兴趣点</p>
                </td>
                <td>
                  <p>
                    <span>居然大厦</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>门</p>
                </td>
                <td>
                  <p>门</p>
                </td>
                <td>
                  <p>
                    <span>花家地南里东门</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>服务示例</li>
          </ul>
        </h3>
        <div class="service-example">
          <p style="text-align:left;word-break:break-all">
            https://lbsapi.meituan.com/v1/location/geo?key=&lt;用户的key&gt;&amp;address=北京市朝阳区望京东路4号&amp;city=北京
          </p>
        </div>
        <coding />
      </div>
      <div id="format-container">
        <h2 id="id-format">地址结构化</h2>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>地址结构化API服务地址</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p>URL</p>
                </th>
                <th>
                  <p>https://lbsapi.meituan.com/v1/format?parameters</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>请求方式</p>
                </td>
                <td>
                  <p>GET</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-request-paramsKeyWord">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>请求参数</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p><strong>参数名</strong></p>
                </th>
                <th width="90">
                  <p><strong>数据类型</strong></p>
                </th>
                <th width="138">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
                <th width="88">
                  <p><strong>是否必填</strong></p>
                </th>
                <th width="70">
                  <p><strong>缺省值</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>key</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>请求服务权限标识</p>
                </td>
                <td>
                  <p>用户申请到的Web服务API Key</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>address</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>地址信息</p>
                </td>
                <td>
                  <p>省+市+区县+街道+门牌号</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>city</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>查询城市</p>
                </td>
                <td>
                  <p>
                    完整的城市名、区县名（如北京市），或其ID（如北京市对应的110100）
                  </p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>model</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>返回结果的表达形式</p>
                </td>
                <td>
                  <p>取值：composite（复合）/simple（简单）</p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>composite</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>stander</p>
                </td>
                <td>
                  <p>bool</p>
                </td>
                <td>
                  <p>返回结果是否标准化</p>
                </td>
                <td>
                  <p>true（标准化）：对部分实体进行标准化操作<br>false（不标准化）：不进行标准化</p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>true</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-返回结果参数说明">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>返回结果参数说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="4">
                  <p><strong>名称</strong></p>
                </th>
                <th>
                  <p><strong>类型</strong></p>
                </th>
                <th>
                  <p>
                    <strong><span>含义</span> </strong>
                  </p>
                </th>
                <th>
                  <p>
                    <strong><span>规则说明</span> </strong>
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="4">
                  <p>status</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>返回结果状态值</p>
                </td>
                <td>
                  <p>
                    200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>
                    。
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p>msg</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>状态描述</p>
                </td>
                <td>
                  <p>
                    当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>
                    。
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p>components</p>
                </td>
                <td>
                  <p v-text="'array<component>'"></p>
                </td>
                <td>
                  <p>结构化地址列表</p>
                </td>
                <td>
                  <p>结果对象列表，包括下述字段：</p>
                </td>
              </tr>
              <tr>
                <td rowspan="10">
                  <p></p>
                </td>
                <td colspan="3">
                  <p>component</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="9">
                  <p></p>
                </td>
                <td colspan="2">
                  <p>name</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>名称</p>
                </td>
                <td>
                  <p>例如：望京东路1号</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>level</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>层级</p>
                </td>
                <td>
                  <p>例如：street_num</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>additional</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>附加信息</p>
                </td>
                <td>
                  <p>例如：1号</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>primary</p>
                </td>
                <td>
                  <p v-text="'array<PrimaryComponent>'"></p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="4">
                  <p></p>
                </td>
                <td>
                  <p>name</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>level</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>additional</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>primary</p>
                </td>
                <td>
                  <p v-text="'array<SubComponent>'"></p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-地址结构化匹配级别列表">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>地址结构化匹配级别列表</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>level</strong> </p>
                </th>
                <th>
                  <p><strong>含义</strong></p>
                </th>
                <th width='88'>
                  <p><strong>数据类型</strong></p>
                </th>
                <th>
                  <p><strong>示例</strong></p>
                </th>
                <th width='135'>
                  <p><strong>对应primary示例</strong></p>
                </th>
                <th>
                  <p><strong>对应primary说明</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>province</p>
                </td>
                <td>
                  <p>省</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>辽宁省</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>city</p>
                </td>
                <td>
                  <p>市</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>北京市</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>district</p>
                </td>
                <td>
                  <p>区县</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>朝阳区</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>region</p>
                </td>
                <td>
                  <p>行政管理区、开发区</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>北京经济技术开发区</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>township</p>
                </td>
                <td>
                  <p>乡/镇/街道</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京街道</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>village</p>
                </td>
                <td>
                  <p>村/庄/社区</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>三元村</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>village_group</p>
                </td>
                <td>
                  <p>村组</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>三元村1组</p>
                </td>
                <td>
                  <p>三元村</p>
                </td>
                <td>
                  <p>对应village类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>village_num</p>
                </td>
                <td>
                  <p>村门牌</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>三元村1号</p>
                </td>
                <td>
                  <p>三元村</p>
                  <p> </p>
                </td>
                <td>
                  <p>对应village类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>road</p>
                </td>
                <td>
                  <p>路</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路西段</p>
                </td>
                <td>
                  <p>望京东路</p>
                </td>
                <td>
                  <p>子路的情况下，如"望京东路西段"存在</p>
                  <p>对应road类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>street_num</p>
                </td>
                <td>
                  <p>门牌号</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路1号</p>
                </td>
                <td>
                  <p>望京东路</p>
                </td>
                <td>
                  <p>对应road类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>func_street</p>
                </td>
                <td>
                  <p>功能街/内部路</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>王府井商业街<br>
                    山厦新村一区五巷</p>
                </td>
                <td>
                  <p>山厦新村一区
                  </p>
                </td>
                <td>
                  <p>实体类型和前面的实体有关</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>road_inter</p>
                </td>
                <td>
                  <p>交叉路口</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路/望京西路</p>
                </td>
                <td>
                  <p>望京东路</p>
                  <p>望京西路</p>
                </td>
                <td>
                  <p>对应多个road类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>road_gap</p>
                </td>
                <td>
                  <p>路口</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路北口</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>poi</p>
                </td>
                <td>
                  <p>兴趣点</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>居然大厦</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>apart</p>
                </td>
                <td>
                  <p>楼栋</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1号楼</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>apart_unit</p>
                </td>
                <td>
                  <p>单元</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1单元</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>gate</p>
                </td>
                <td>
                  <p>门</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>花家地南里东门</p>
                </td>
                <td>
                  <p>花家地南里</p>
                </td>
                <td>
                  <p>实体类型与门前面的实体有关</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>floor</p>
                </td>
                <td>
                  <p>楼层</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1层</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>room</p>
                </td>
                <td>
                  <p>房间号</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>101室</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>offset</p>
                </td>
                <td>
                  <p>偏移</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>花家地南里东100米</p>
                </td>
                <td>
                  <p>花家地南里</p>
                </td>
                <td>
                  <p>实体类型与偏移前面的实体有关</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>服务示例</li>
          </ul>
        </h3>
        <div class="service-example">
          <p style="text-align:left;word-break:break-all">
            https://lbsapi.meituan.com/v1/format?key=&lt;用户的key&gt;&amp;address=北京市朝阳区望京东路4号&amp;city=北京&amp;model=simple&amp;stander=false
          </p>
        </div>
        <format :parameter="true" />
      </div>
      <div id="format-container">
        <h2 id="id-formatV2">地址结构化V2</h2>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li >地址结构化V2 API服务地址</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p>URL</p>
                </th>
                <th>
                  <p >https://lbsapi.meituan.com/v2/format?parameters</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>请求方式</p>
                </td>
                <td>
                  <p>GET</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-request-paramsKeyWord">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>请求参数</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p><strong>参数名</strong></p>
                </th>
                <th width="90">
                  <p><strong>数据类型</strong></p>
                </th>
                <th width="138">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
                <th width="88">
                  <p><strong>是否必填</strong></p>
                </th>
                <th width="70">
                  <p><strong>缺省值</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>key</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>请求服务权限标识</p>
                </td>
                <td>
                  <p>用户申请到的Web服务API Key</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>address</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>地址信息</p>
                </td>
                <td>
                  <p>省+市+区县+街道+门牌号</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>city</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>查询城市</p>
                </td>
                <td>
                  <p>
                    完整的城市名、区县名（如北京市），或其ID（如北京市对应的110100）
                  </p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>model</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>返回结果的表达形式</p>
                </td>
                <td>
                  <p>取值：composite（复合）/simple（简单）</p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>composite</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>stander</p>
                </td>
                <td>
                  <p>bool</p>
                </td>
                <td>
                  <p>返回结果是否标准化</p>
                </td>
                <td>
                  <p>true（标准化）：对部分实体进行标准化操作<br>false（不标准化）：不进行标准化</p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>true</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p >remove_duplication</p>
                </td>
                <td>
                  <p >bool</p>
                </td>
                <td>
                  <p >是否对原始地址去重</p>
                </td>
                <td>
                  <p >true：去重 false：不去重</p>
                </td>
                <td>
                  <p >否</p>
                </td>
                <td>
                  <p >true</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-返回结果参数说明">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>返回结果参数说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="4">
                  <p><strong>名称</strong></p>
                </th>
                <th>
                  <p><strong>类型</strong></p>
                </th>
                <th>
                  <p>
                    <strong><span>含义</span> </strong>
                  </p>
                </th>
                <th>
                  <p>
                    <strong><span>规则说明</span> </strong>
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="4">
                  <p>status</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>返回结果状态值</p>
                </td>
                <td>
                  <p>
                    200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>
                    。
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p>msg</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>状态描述</p>
                </td>
                <td>
                  <p>
                    当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>
                    。
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p>components</p>
                </td>
                <td>
                  <p  v-text="'array<component>'"></p>
                </td>
                <td>
                  <p>结构化地址列表</p>
                </td>
                <td>
                  <p>结果对象列表，包括下述字段：</p>
                </td>
              </tr>
              <tr>
                <td rowspan="10">
                  <p></p>
                </td>
                <td colspan="3">
                  <p >component</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="9">
                  <p></p>
                </td>
                <td colspan="2">
                  <p>name</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>名称</p>
                </td>
                <td>
                  <p>例如：望京东路1号</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>level</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>层级</p>
                </td>
                <td>
                  <p>例如：street_num</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>additional</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>附加信息</p>
                </td>
                <td>
                  <p>例如：1号</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>primary</p>
                </td>
                <td>
                  <p v-text="'array'"></p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="4">
                  <p></p>
                </td>
                <td>
                  <p>name</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>level</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>additional</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>primary</p>
                </td>
                <td>
                  <p v-text="'array'"></p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-地址结构化V2匹配级别列表">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li style="font-size:15px">地址结构化V2 匹配级别列表</li>
            <li>复合实体形式说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>level</strong> </p>
                </th>
                <th>
                  <p><strong>含义</strong></p>
                </th>
                <th width='88'>
                  <p><strong>数据类型</strong></p>
                </th>
                <th>
                  <p><strong>示例</strong></p>
                </th>
                <th width='135'>
                  <p><strong>对应primary示例</strong></p>
                </th>
                <th>
                  <p><strong>对应primary说明</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>province</p>
                </td>
                <td>
                  <p>省</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>辽宁省</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>city</p>
                </td>
                <td>
                  <p>市</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>北京市</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>district</p>
                </td>
                <td>
                  <p>区县</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>朝阳区</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>region</p>
                </td>
                <td>
                  <p>行政管理区、开发区</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>北京经济技术开发区</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>township</p>
                </td>
                <td>
                  <p>乡/镇/街道</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京街道</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>village</p>
                </td>
                <td>
                  <p>村/庄/社区</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>三元村</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>village_group</p>
                </td>
                <td>
                  <p>村组</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>三元村1组</p>
                </td>
                <td>
                  <p>三元村</p>
                </td>
                <td>
                  <p>对应village类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>village_num</p>
                </td>
                <td>
                  <p>村门牌</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>三元村1号</p>
                </td>
                <td>
                  <p>三元村</p>
                  <p> </p>
                </td>
                <td>
                  <p>对应village类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>road</p>
                </td>
                <td>
                  <p>路</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路西段</p>
                </td>
                <td>
                  <p>望京东路</p>
                </td>
                <td>
                  <p>子路的情况下，如"望京东路西段"存在</p>
                  <p>对应road类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>street_num</p>
                </td>
                <td>
                  <p>门牌号</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路1号</p>
                </td>
                <td>
                  <p>望京东路</p>
                </td>
                <td>
                  <p>对应road类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>func_street</p>
                </td>
                <td>
                  <p>功能街/内部路</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>王府井商业街<br>
                    山厦新村一区五巷</p>
                </td>
                <td>
                  <p>山厦新村一区
                  </p>
                </td>
                <td>
                  <p>实体类型和前面的实体有关</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>road_inter</p>
                </td>
                <td>
                  <p>交叉路口</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路/望京西路</p>
                </td>
                <td>
                  <p>望京东路</p>
                  <p>望京西路</p>
                </td>
                <td>
                  <p>对应多个road类型实体</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>road_gap</p>
                </td>
                <td>
                  <p>路口</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路北口</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p >aoi</p>
                </td>
                <td>
                  <p>兴趣面（学校、小区、医院、广场等面积较大的poi）</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>花家地南里</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>sub_aoi</p>
                </td>
                <td>
                  <p>子兴趣面(大的aoi的子区域)</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>花家地南里二期</p>
                </td>
                <td>
                  <p>花家地南里</p>
                </td>
                <td>
                  <p>对应aoi实体类型</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>poi</p>
                </td>
                <td>
                  <p>兴趣点</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>居然大厦</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
             <tr>
                <td colspan="2">
                  <p  >sub_poi</p>
                </td>
                <td>
                  <p>子兴趣点(空间上包含在poi部）</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>居然大厦(poi)1层肯德基(sub_poi)</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
               <tr>
                <td colspan="2">
                  <p >fac_poi</p>
                </td>
                <td>
                  <p>设施类兴趣点(文本无独立意义，且空间无独立意义或极小，一般为附属设施，实现某种功能，如电梯、办公室、医院的科室,保安亭,门卫）</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>办公室、快递柜、</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>apart</p>
                </td>
                <td>
                  <p>楼栋</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1号楼</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>apart_unit</p>
                </td>
                <td>
                  <p>单元</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1单元</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>gate</p>
                </td>
                <td>
                  <p>门</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>花家地南里东门</p>
                </td>
                <td>
                  <p>花家地南里</p>
                </td>
                <td>
                  <p>实体类型与门前面的实体有关</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>floor</p>
                </td>
                <td>
                  <p>楼层</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1层</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>room</p>
                </td>
                <td>
                  <p>房间号</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>101室</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>offset</p>
                </td>
                <td>
                  <p>偏移</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>花家地南里东100米</p>
                </td>
                <td>
                  <p>花家地南里</p>
                </td>
                <td>
                  <p>实体类型与偏移前面的实体有关</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p >person</p>
                </td>
                <td>
                  <p>人名</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>李雷</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p >tel</p>
                </td>
                <td>
                  <p>电话</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>18902345678</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
          <h3 id="id-地址结构化V2匹配级别列表">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>简单实体形式说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>字段名</strong> </p>
                </th>
                <th>
                  <p><strong>含义</strong></p>
                </th>
                <th width='88'>
                  <p><strong>数据类型</strong></p>
                </th>
                <th>
                  <p><strong>示例</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>province</p>
                </td>
                <td>
                  <p>省</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>辽宁省</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>city</p>
                </td>
                <td>
                  <p>市</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>北京市</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>district</p>
                </td>
                <td>
                  <p>区县</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>朝阳区</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>region</p>
                </td>
                <td>
                  <p>行政管理区、开发区</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>北京经济技术开发区</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>township</p>
                </td>
                <td>
                  <p>乡/镇/街道</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京街道</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>village</p>
                </td>
                <td>
                  <p>村/庄/社区</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>三元村</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>village_group</p>
                </td>
                <td>
                  <p>村组</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1组</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>village_num</p>
                </td>
                <td>
                  <p>村门牌</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1号</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>road</p>
                </td>
                <td>
                  <p>路</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p >sub_road</p>
                </td>
                <td>
                  <p>子路/路段</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>西段</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>street_num</p>
                </td>
                <td>
                  <p>门牌号</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1号</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>func_street</p>
                </td>
                <td>
                  <p>功能街/内部路</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>王府井商业街</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>road_gap</p>
                </td>
                <td>
                  <p>路口</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>望京东路北口</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p >aoi</p>
                </td>
                <td>
                  <p>兴趣面（学校、小区、医院、广场等面积较大的poi）</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>花家地南里</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p >sub_aoi</p>
                </td>
                <td>
                  <p>子兴趣面(大的aoi的子区域)</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>一期</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>poi</p>
                </td>
                <td>
                  <p>兴趣点</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>居然大厦</p>
                </td>
              </tr>
             <tr>
                <td colspan="2">
                  <p  >sub_poi</p>
                </td>
                <td>
                  <p>子兴趣点(空间上包含在poi部）</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>居然大厦(poi)1层肯德基(sub_poi)</p>
                </td>
              </tr>
               <tr>
                <td colspan="2">
                  <p >fac_poi</p>
                </td>
                <td>
                  <p>设施类兴趣点(文本无独立意义，且空间无独立意义或极小，一般为附属设施，实现某种功能，如电梯、办公室、医院的科室,保安亭,门卫）</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>办公室、快递柜、</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>apart</p>
                </td>
                <td>
                  <p>楼栋</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1号楼</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>apart_unit</p>
                </td>
                <td>
                  <p>单元</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1单元</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>gate</p>
                </td>
                <td>
                  <p>门</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>东门</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>floor</p>
                </td>
                <td>
                  <p>楼层</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>1层</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>room</p>
                </td>
                <td>
                  <p>房间号</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>101室</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>offset</p>
                </td>
                <td>
                  <p>偏移</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>东100米</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p >person</p>
                </td>
                <td>
                  <p>人名</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>李雷</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p >tel</p>
                </td>
                <td>
                  <p>电话</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>18902345678</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>服务示例</li>
          </ul>
        </h3>
        <div class="service-example">
          <p style="text-align:left;word-break:break-all">
            https://lbsapi.meituan.com/v2/format?key=&lt;用户的key&gt;&amp;address=北京市朝阳区望京东路4号&amp;city=北京&amp;model=simple&amp;stander=false&amp;remove_duplication=false
          </p>
        </div>
        <format :parameter="true" :removeDuplication="true" />
      </div>
    </div>
  </div>
</template>
<script>
import 'vue-json-pretty/lib/styles.css'
import '@ss/mtd-vue/lib/theme2/anchor.css'
import '@ss/mtd-vue/lib/theme2/anchor-link.css'
import Anchor from '@/views/support/anchor/anchor.vue'
import AnchorLink from '@/views/support/anchor/anchor-link.vue'
import Coding from './Coding.vue'
import Format from './Format.vue'
export default {
  components: {
    Anchor,
    AnchorLink,
    Coding,
    Format
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="less" scoped>
@import '../document.less';

.title-wrap {
  position: absolute;
  right: 0px;
  top: 100px;
  .mtd-anchor .mtd-anchor-link {
    font-size: 14px !important;
  }
}

/deep/.mtd-anchor-link-active .mtd-anchor-link-title {
  color: #a46e00 !important;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
/deep/.title-wrap .mtd-anchor-ink-ball {
  background-color: #ffd100 !important;
}
/deep/ .mtd-anchor-link-title:hover {
  color: #a46e00;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
</style>
